// Missing several props and methods from core implementation, as well as the PrivacyToggleContainer implementation.

import React from 'react';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryCommentEditor } from '@bibliocommons/shared-ugc-editors';
import { currentUserSelector } from '../../selectors/AuthSelector';

class PrimaryCommentEditorContainer extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      showForm: true,
      initialComment: '',
      comment: '',
      bibId: props.bibId,
      isNew: true,
      userContentId: null,
      expanded: false,
      initializingStatus: {
        status: 'success',
        localeKey: null
      },
      user: props.user
    };

    this.bindAll('handleChange', 'handleFocus', 'handleBlur');
  }

  static handleLogin(e) {
    e.preventDefault();
  }

  static handleSubmit(e) {
    e.preventDefault();
  }

  handleFocus() {
    this.setState({
      expanded: true
    });
  }

  handleBlur() {
    this.setState({
      expanded: false
    });
  }

  handleChange(value) {
    this.setState({
      comment: value,
      isEmpty: value.length <= 0
    });
  }

  render() {
    return (
      <PrimaryCommentEditor
        characterLimit={4000}
        bibId={this.props.bibId}
        comment={this.state.comment}
        expanded={this.state.expanded}
        handleLogin={PrimaryCommentEditorContainer.handleLogin}
        handleBlur={this.handleBlur}
        handleChange={this.handleChange}
        handleFocus={this.handleFocus}
        isNew={this.state.isNew}
        showForm={this.state.showForm}
        handleSubmit={PrimaryCommentEditorContainer.handleSubmit}
        isEmpty={this.state.isEmpty}
        metadataId={this.props.metadataId}
        user={this.state.user}
        userContentId={this.state.userContentId}
        initializingStatus={this.state.initializingStatus}
        isPrivate={false}
        handlePrivacyToggle={(e) => { e.preventDefault(); }} />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const user = currentUserSelector(state);
  const editorUser = user ? {
    loggedIn: true,
    id: user.id,
    // idHash: '',
    allowFreeText: true
  } : { loggedIn: false };

  return {
    bibId: ownProps.bibId,
    metadataId: ownProps.metadataId,
    user: editorUser
  };
};

export default connect(mapStateToProps)(PrimaryCommentEditorContainer);



// WEBPACK FOOTER //
// ./app/containers/UGCTestContainers/PrimaryCommentEditorContainer.jsx